import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=1359410e&scoped=true&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"
import style0 from "./Colors.vue?vue&type=style&index=0&id=1359410e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359410e",
  null
  
)

export default component.exports